import About from './Home/About';
import Hero from './Home/Hero';
import Services from './Home/Services';
import { useEffect } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';
import Team from './Home/Team';
import Blog from './Home/Blog';

export function AddLibrary(urlOfTheLibrary) {
  const script = document.createElement('script');
  script.src = urlOfTheLibrary;
  script.setAttribute("crossorigin", "anonymous");
  document.body.appendChild(script);
  return script;
}

export function RemoveLibrary(urlOfTheLibrary) {
  const script = document.createElement('script');
  script.src = urlOfTheLibrary;
  script.setAttribute("crossorigin", "anonymous");
  document.body.appendChild(script);
}


const Home = () => {

  useEffect(() => {
    AOS.init();
    AOS.refresh();
    document.title = "The Michael's Technologies - TMT";
    window.scrollTo(0, 0)

    const script5 = AddLibrary(process.env.PUBLIC_URL + 'assets/js/plugins/swiper-bundle.min.js')
    const script6 = AddLibrary(process.env.PUBLIC_URL + 'assets/js/plugins/aos.js')
    const script7 = AddLibrary(process.env.PUBLIC_URL + 'assets/js/plugins/waypoints.min.js')
    const script8 = AddLibrary(process.env.PUBLIC_URL + 'assets/js/plugins/back-to-top.js')
    const script9 = AddLibrary(process.env.PUBLIC_URL + 'assets/js/plugins/jquery.counterup.min.js')
    const script10 = AddLibrary(process.env.PUBLIC_URL + 'assets/js/plugins/appear.min.js')
    const script11 = AddLibrary(process.env.PUBLIC_URL + 'assets/js/plugins/jquery.magnific-popup.min.js')
    const script12 = AddLibrary(process.env.PUBLIC_URL + 'assets/js/main.js')

    return () => {

      document.body.removeChild(script5);
      document.body.removeChild(script6);
      document.body.removeChild(script7);
      document.body.removeChild(script8);
      document.body.removeChild(script9);
      document.body.removeChild(script10);
      document.body.removeChild(script11);
      document.body.removeChild(script12);
    }
  }, []);

  return (
    <div className="home">

      <Hero />
      <Services />
      <About />
      {/* <Team /> */}
      <Blog />
    </div>
  );
}

export default Home;